export default {
  translation: {
    common: {
      accept: 'Accetta',
      alreadyUser: 'Gia utente?',
      and: 'e',
      backToLogin: 'Torna alla pagina di login',
      continueWith: 'Continua con {{provider}}',
      coreNotFound: 'Impossibile recuperare le impostazioni di base',
      createAccount: 'Crea un account',
      createYourAccount: 'Crea il tuo account',
      emailOrUsername: 'Email o nome utente',
      invalidUsernameOrPassword: 'Nome utente o password non validi',
      localRegistrationDisabled: "Registrazione locale disabilitata dall'amministratore",
      login: 'Accedi',
      logInToBoards: 'Accedi',
      newToBoards: 'Nuovo su 4ga Boards?',
      noInternetConnection: 'Nessuna connessione internet',
      pageNotFound_title: 'Pagina non trovata',
      password: 'Password',
      policyNotAccepted: 'Accetta Termini di servizio e Informativa sulla privacy',
      privacyPolicy: 'Informativa sulla privacy',
      register: 'Registrati',
      registerWithGoogle: 'Registrati con Google',
      registrationDisabled: "Registrazione utenti disabilitata dall'amministratore",
      serverConnectionFailed: 'Connessione al server fallita',
      ssoRegistrationDisabled: "Registrazione SSO disabilitata dall'amministratore",
      termsOfService: 'Termini di servizio',
      togglePasswordVisibility: 'Mostra/nascondi password',
      unknownError: 'Errore sconosciuto, riprova piu tardi',
    },

    action: {
      logIn: 'Accedi',
    },
  },
};
